<template>
  <v-card
    style="padding: 20px;"
  >
    <small>Totem tareas permitidas:</small>
    <v-row v-if="allTasks">
      <v-col
        cols="12"
        sm="12"
        md="6"
        lg="6"
        v-for="item of allTasks"
        :key="item.id"
      >
        
        <v-checkbox
          v-model="editedItem"
          :label="item.name"
          :value="item.id"
          multiple
          hide-details
          @change="handleChange"
        />
      </v-col>
    </v-row>
    <small style="color: #CCCCCC;">
      [NOTA] requiere cerrar sesi&oacute;n
    </small>
  </v-card>
</template>
<script>
import api from '@/services/api'
export default {
  props: {
    value: {
      type: String,
      required: false,
    },
    onChange: {
      type: Function,
      required: true,
    },
  },
  data: () => ({
    editedItem: [],
    allTasks: null,
  }),
  watch: {
    value () {
      this.prepareData()
    },
  },
  mounted () {
    this.prepareData()
    this.handleGetAllTask()
  },
  methods: {
    prepareData () {
      if (this.value !== JSON.stringify(this.editedItem))
        this.editedItem = this.value ? JSON.parse(this.value) : []
    },
    handleGetAllTask () {
      api.getAllWithoutLimit ('players', 'v1/internal/constants/totem-task')
        .then(response => {
          this.allTasks = response
        })
    },
    handleChange () {
      this.onChange(JSON.stringify(this.editedItem))
    },
  },
}
</script>
